"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.h5Login = void 0;
var env_1 = __importDefault(require("@tencent/vft-common/env"));
var AppLogin_1 = __importDefault(require("./AppLogin"));
var H5Login_1 = __importDefault(require("./H5Login"));
exports.default = env_1.default.isApp ? new AppLogin_1.default() : new H5Login_1.default();
// 文档 https://git.woa.com/WeTV/WPC/common/sdk/wpc-wetv-login-sdk/blob/master/readme.md
exports.h5Login = window.wetvLogin;
